import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslatedBundleGuard } from '@dia/dialog-reusable-components';
import { QnSbnEservicesComponent } from './features/qn-sbn-eservices/qn-sbn-eservices.component';
import { CreateNotificationComponent } from './features/qn-sbn-eservices/create-notification/create-notification.component';
import { NotificationTitleComponent } from './features/qn-sbn-eservices/create-notification/notification-title/notification-title.component';
import { NotificationDocComponent } from './features/qn-sbn-eservices/create-notification/notification-doc/notification-doc.component';
import { MessageAttachmentComponent } from './features/qn-sbn-eservices/create-notification/message-attachment/message-attachment.component';
import { ConfigureFeedbackComponent } from './features/qn-sbn-eservices/create-notification/configure-feedback/configure-feedback.component';
import { DueDateReminderComponent } from './features/qn-sbn-eservices/create-notification/due-date-reminder/due-date-reminder.component';
import { RecipientslistComponent } from './features/qn-sbn-eservices/create-notification/recipientslist/recipients-list/recipients-list.component';
import { NotificationComponent } from './features/qn-sbn-eservices/notification/notification.component';
import { NotificationDetailsComponent } from './features/qn-sbn-eservices/notification/notification-details/notification-details.component';
import { ContactDetailsComponent } from './features/qn-sbn-eservices/notification/contact-details/contact-details.component';
import { UniqueIdDialogComponent } from './features/qn-sbn-eservices/notification/unique-id-dialog/unique-id-dialog.component';
import { NotificationAuditTrailComponent } from './features/qn-sbn-eservices/notification/notification-audit-trail/notification-audit-trail.component';
import { AccountDetailsComponent } from './features/qn-sbn-eservices/notification/account-details/account-details.component';
import { EmailDeliveryComponent } from './features/qn-sbn-eservices/email-delivery/email-delivery.component';
import { DashboardComponent } from './features/qn-sbn-eservices/dashboard/dashboard.component';
import { DailySummaryReportComponent } from './features/qn-sbn-eservices/create-notification/daily-summary-report/daily-summary-report.component';
export const appRouterModule: Routes = [
  {
    path: '',
    redirectTo: '/notification',
    pathMatch: 'full'
  },
  {
    path: 'qnsbn-eservice',
    component: QnSbnEservicesComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'notification',
    component: NotificationComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'notification-details',
    component: NotificationDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'create-local-notification',
    component: UniqueIdDialogComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'contact-details',
    component: ContactDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'account-details',
    component: AccountDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'notification-audit-trail',
    component: NotificationAuditTrailComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'create-notification',
    component: CreateNotificationComponent,
    data: { trackWithAnalytics: true },
    // loadChildren: () => import('./features/qn-sbn-eservices/create-notification/create-notification.module').then(m => m.CreateNotificationModule)
    children: [
      {
        path: '',
        redirectTo: 'notification-title',
        pathMatch: 'full'
      },
      {
        path: 'notification-title',
        component: NotificationTitleComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: 'notification-doc',
        component: NotificationDocComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: 'recipients',
        component: RecipientslistComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: 'message-attachment',
        component: MessageAttachmentComponent,
        data: { trackWithAnalytics: true }
      }, 
      {
        path: 'configure-feedback',
        component: ConfigureFeedbackComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: 'due-date-reminder',
        component: DueDateReminderComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: 'daily-summary-report',
        component: DailySummaryReportComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: '**',
        redirectTo: '/notification-title',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'email-delivery',
    component: EmailDeliveryComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: '**',
    redirectTo: '/notification',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRouterModule, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRouterModule {}
